import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

import { AppService } from 'src/app/app.service';
import { OrderService } from 'src/app/_services/order.service';
import { OrderItemsUtilsService } from 'src/app/order-items/order-items-util.service';
import { OfferItemDialogComponent } from '../offer-item-dialog/offer-item-dialog.component';

import * as _ from 'lodash';
declare const $: any;

@Component({
    selector: 'app-item-group',
    templateUrl: './item-group.component.html',
    styleUrl: './item-group.component.scss',
    standalone: false
})
export class ItemGroupComponent implements OnInit {
	@Input() public viewItem;
	@Input() public currentItem;
	@Input() public group;
	@Input() public workMode = 'inline';

	@Output() public onMemberSelect: any = new EventEmitter();

	$storage;
	catalog;
	showItemDescription: boolean = false;
	constructor(
		public appService: AppService,
		public orderService: OrderService,
		public orderUtils: OrderItemsUtilsService,
		public dialog: MatDialog
	) {
		this.$storage = this.orderService.$storage;
		this.catalog = this.$storage.catalog;
	}

	ngOnInit() {
		this.showItemDescription = this.group.showItemDescription;
	}

	// ----------------------------------------------------------------------------->
	// selection groups
	// ----------------------------------------------------------------------------->

	addRemoveItemStart(group, member, ev) {
		if (member.stockDisabled) {
			return this.appService.alert({
				content: this.appService.translate('MESSAGES.ITEM_OUT_OF_STOCK_MESSAGE', { item: member.name }),
			});
		}

		ev.stopPropagation();
		let $h = $(ev.currentTarget);
		if ($h.hasClass('popactive')) {
			$h.removeClass('popactive')
			return;
		}
		$('.popactive').removeClass('popactive');
		$h.addClass('popactive');
		if (!member.count) this.addRemoveItem(group, member, true, ev);
	}

	addRemoveItem(group, member, doAdd, ev?) {
		if (ev) ev.stopPropagation();
		let that = this;
		if (doAdd) {
			if (!member.count) {
				this.toggleSelectionGroupItem(group, member);
			} else {
				var selectionCount = this.orderUtils.getItemGroupSelectionCount(group);
				var count = group.selectionCount;
				if (selectionCount == count) {
					this.appService.alert({ content: this.appService.translate('GROUP_VALIDATION.SELECT_UPTO_SOME', { max: count }) });
					return;
				}
				++member.count;
				that.viewItem.total += member._item.total;
				that.orderUtils.prepareOfferSelectionGroups(that.viewItem);
				this.checkQuickAdd();
			}

		} else {
			if (member.count > 1) {
				if (member._item.total) that.viewItem.total -= member._item.total;
				--member.count;
			} else {
				that.clearSelectionGroupItem(group, member);
				that.orderUtils.prepareOfferSelectionGroups(that.viewItem);
			}
		}
	}

	editItemGroupItem(group, member, e?) {
		if (e) e.stopPropagation();
		this.toggleSelectionGroupItem(group, member, true);
	}

	toggleSelectionGroupItem(group, member, forceEdit?) {
		if (member.stockDisabled) {
			return this.appService.alert({
				content: this.appService.translate('MESSAGES.ITEM_OUT_OF_STOCK_MESSAGE', { item: member.name }),
			});
		}
		let that = this;
		if (member._selected) {
			if (forceEdit || member.$wasEdit) {
				this.showSelectionGroupItemModal({
					viewItem: this.viewItem,
					groupItem: member,
					group: group,
					currentItem: member._item,
					isEditSGItem: true
				})

			} else {
				this.clearSelectionGroupItem(group, member);
			}
		} else {
			var count = group.selectionCount;
			var selectionCount = this.orderUtils.getItemGroupSelectionCount(group);
			if (count > 1) {
				if (selectionCount == count) {
					this.appService.alert({ content: this.appService.translate('GROUP_VALIDATION.SELECT_UPTO_SOME', { max: count }) });
					return;
				}
			}
			if (member._item.summary) {

			} else {
				that.orderUtils.prepareItem(that.catalog, member._item, that.viewItem);
			}
			if (!member._item.total) member._item.total = 0
			if (_.isUndefined(member._item._total)) member._item._total = member._item.total;


			if (!forceEdit && (!member._item._hasModifierGroups || !member._item._hasRequiered)) {
				that.addSelectionGroupItem(group, member);
				that.orderUtils.prepareOfferSelectionGroups(that.viewItem);
				this.checkQuickAdd();
			} else {
				that.showSelectionGroupItemModal({
					viewItem: this.viewItem,
					groupItem: member,
					group: group,
					currentItem: member._item
				})
			}
		}
	}

	clearSelectionGroupItem(group, member, e?) {
		if (e) e.stopPropagation();
		delete member._selected;
		let _item = member._item;
		if (_item) {

			if (_item.total) this.viewItem.total -= member.count * _item.total;
			delete _item.oldTotal;
			_item.total = _item._total;

			delete member._item.oldTotal;
			member._item.total = member._item._total;
			delete member._item.summary;

			_.each(member._item.modifierGroups, group => {
				if (group.singleSelection) {
					_.each(group.modifiers, modifier => {
						if (modifier._isDefault) {
							modifier._selected = true;
						} else {
							delete modifier._selected;
						}
					})
				} else {
					_.each(group.modifiers, modifier => {
						if (!modifier.compulsory) {
							if (modifier.$isDefault) {
								modifier.formationUnit = modifier.defaultFormationUnit;
								modifier.count = 1;
							} else {
								delete modifier.formationUnit;
								modifier.count = 0;
							}
						}
					})
				}
			})

		};
		delete group._expandable;
		delete group._collpased;
		delete member.count;
		this.orderUtils.prepareOfferSelectionGroups(this.viewItem);
	}

	addSelectionGroupItem(group, member, isEdit?) {
		let that = this;
		var selectionCount = this.orderUtils.getItemGroupSelectionCount(group);
		if (!isEdit) {
			var count = group.selectionCount;
			var selected: any = _.filter(group.items, { '_selected': true });
			var selectedN = selected.length;
			if (count == 1) {
				if (selectionCount) {
					var _item = selected[0] && selected[0]._item;
					if (_item) {
						this.clearSelectionGroupItem(group, selected[0]);
					}
					--selectedN;

				}
			}
		}
		if (!member.count) member.count = 1;

		var oldTotal = member._item.oldTotal || 0;
		var newTotal = member._item.total || 0;

		that.viewItem.total -= member.count * oldTotal;
		that.viewItem.total += member.count * newTotal;
		member._item.oldTotal = newTotal;

		member._selected = true;
		delete group._requiered;

		if (!isEdit) {
			if (count == selectedN + 1) {
				group._expandable = true;
				group._collpased = true;
			}
		}
	}

	showSelectionGroupItemModal(args) {
		let originalItam = _.cloneDeep(args.groupItem?._item);
		let dialogRef = this.dialog.open(OfferItemDialogComponent, {
			panelClass: ['to-offer-dialog', 'animated', 'slideInLeft'],
			data: args,
			autoFocus: false
		});
		dialogRef.afterClosed().subscribe(result => {
			if (result) {
				if (result.isClear) {
					this.clearSelectionGroupItem(args.group, args.groupItem);
				} else {
					this.orderUtils.prepareItemSummary(result.groupItem._item, true);
					args.groupItem.$wasEdit = true;
					result.groupItem.count = args.groupItem.count;
					result.groupItem._selected = false;
					this.addSelectionGroupItem(result.group, result.groupItem, args.isEditSGItem);
					this.orderUtils.prepareOfferSelectionGroups(this.viewItem);
					this.checkQuickAdd();
				}
			} else {
				args.groupItem._item = originalItam;
			}
		});
	}

	checkQuickAdd() {
		let group = this.group;
		if (group.enableQuickItemFlow && this.workMode == 'wizard') {
			let count = group.selectionCount;
			if (count) {
				var selectionCount = this.orderUtils.getItemGroupSelectionCount(group);
				if (count == selectionCount) this.onMemberSelect.emit();
			}
		}
	}

	collapseGroup(group) {
		group.collapsed = !group.collapsed;
	}

}

